import RpcTypes from 'constants/rpcTypes';
import RpcService from 'helpers/RpcService';

export const getAnalysisDataByCodeName = (payload: {
  blockCode: string;
  currency: string;
  periodType?: string;
}) => {
  return new RpcService().request({
    messages: [
      {
        type: RpcTypes.Home_GetInfoBlock,
        payload,
      },
    ],
  });
};
